import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VContainer,[_c(VLayout,{attrs:{"row":"","wrap":""}},[_c(VFlex,{attrs:{"xs12":"","md10":"","offset-md1":"","xl8":"","offset-xl2":""}},[(_vm.loading)?_c(VProgressCircular,{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),(_vm.isAuthed && !_vm.loading && _vm.redirects)?_c('LiveLine',{attrs:{"chartdata":_vm.liveData,"options":_vm.options}}):_vm._e()],1)],1)],1),(!_vm.isAuthed)?_c('SignIn'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }